import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, finalize, takeUntil } from 'rxjs';
import { AuthUser } from 'src/app/model/auth-user';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-personal-information-page',
  templateUrl: './personal-information-page.component.html',
  styleUrls: ['./personal-information-page.component.css'],
})
export class PersonalInformationPageComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private currentUser: AuthUser | null = null;

  isEditMode = false;
  name = '';
  email = '';
  phone = '';
  isSaving = false;
  errorMessage = '';

  constructor(
    private readonly router: Router,
    public readonly appModeService: AppModeService,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService.currentUser$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (!user) {
        const lang = localStorage.getItem('lang') || 'en';
        this.router.navigateByUrl(`/${lang}/home`);
        return;
      }

      this.currentUser = user;
      this.name = user.name || '';
      this.email = user.email || '';
      this.phone = user.phone || '';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(): void {
    const lang = localStorage.getItem('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/profile`);
  }

  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;
    this.errorMessage = '';

    if (!this.isEditMode && this.currentUser) {
      this.name = this.currentUser.name || '';
      this.email = this.currentUser.email || '';
      this.phone = this.currentUser.phone || '';
    }
  }

  onSave(): void {
    const trimmedName = this.name.trim();
    if (!trimmedName) {
      this.errorMessage = 'PROFILE.ERROR_NAME_REQUIRED';
      return;
    }

    if (!/^\+?[0-9\s\-]{0,20}$/.test(this.phone || '')) {
      this.errorMessage = 'PROFILE.ERROR_PHONE_INVALID';
      return;
    }

    this.isSaving = true;
    this.errorMessage = '';

    this.authService
      .updateProfile(trimmedName, this.phone || null)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe({
        next: () => {
          this.isEditMode = false;
        },
        error: () => {
          this.errorMessage = 'PROFILE.ERROR_SAVE_FAILED';
        },
      });
  }
}
